export default __webpack_public_path__ + "static/media/C5.aab9641a.mp3";